import _ from 'underscore';

import { isMyCollectionsSubspace,SpaceInfo } from '~src/app/state/SpaceInfo';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionDefinition,OptionsDictionary } from './SortOptionDefinitions';

export const defaultCollectionSort = [Order.asc(OrderKeys.name)];

const permissionedItemCountOption: OptionDefinition = {
  id: 'permissionedItemCount',
  getMenuItemDisplayValue: Messages.collectionItemCountColumn,
  subSortOptions: {
    'desc': {
      id: 'permissionedItemCount.desc',
      field: OrderKeys.permissionedItemCount,
      getMenuItemDisplayValue: Messages.sortByMostLeast,
      getButtonDisplayValue: Messages.sortByItemsDesc,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.permissionedItemCount)]
    },
    'asc': {
      id: 'permissionedItemCount.asc',
      field: OrderKeys.permissionedItemCount,
      getMenuItemDisplayValue: Messages.sortByLeastMost,
      getButtonDisplayValue: Messages.sortByItemsAsc,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.permissionedItemCount)]
    }
  }
};

export function getCollectionsSortOptions(spaceInfo: SpaceInfo) {
  if (FeatureFlags.collectionsGAEnabled) {
    if (isMyCollectionsSubspace(spaceInfo)) {
      return _.omit(collectionsSortOptionsWithCollectionsGA, 'owner');
    }
    return collectionsSortOptionsWithCollectionsGA;
  } else {
    return collectionsSortOptions;
  }
}

export const collectionsSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'createdTime': SortOptions.createdTime,
  'updatedTime': SortOptions.updatedTime,
};

export const collectionsSortOptionsWithCollectionsGA: OptionsDictionary = {
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'permissionedItemCount': permissionedItemCountOption,
  'createdTime': SortOptions.createdTime,
  'updatedTime': SortOptions.updatedTime,
};
